import React, { useEffect, useState } from 'react'

import * as S from './FileTab.style'
import { alertError, alertSuccess } from 'api'
import ColaSourcesTable from '../ColaSourceTab'
import { FileUpload } from '../UploadWindow/file-upload'
import { getColaKnowledgeFiles, knowledgeFileService } from 'tabs/nlp/api/knowledgeFile'

export const ColaFileTab = () => {
  const [sources, setSources] = useState([])

  useEffect(() => {
    fetchTrainingFiles()
  }, [])

  const fetchTrainingFiles = () => {
    getColaKnowledgeFiles().then(res => {
      setSources(res || [])
    })
  }

  const updateSource = updatedSource => {
    setSources(prevSources => prevSources.map(source => (source._id === updatedSource._id ? updatedSource : source)))
  }

  const handleDelete = (source: string) => {
    knowledgeFileService
      .deleteKnowledgeFile(source)
      .then(() => {
        setSources(prevSources => prevSources.filter(x => x._id !== source))
      })
      .then(() => alertSuccess('File is deleted successfully'))
      .catch(error => alertError(error?.message || 'Something went wrong'))
  }

  return (
    <S.FileTab>
      <FileUpload updateTrainedFilesCallBack={fetchTrainingFiles} listNames={sources.map(source => source.originalFilename)} />
      <ColaSourcesTable
        sources={sources}
        onDelete={handleDelete}
        updateSource={updateSource}
        fetchTrainingFiles={fetchTrainingFiles}
      />
    </S.FileTab>
  )
}
